import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * This week's transactions list - inherits from all-transactions with date filter for last 7 days
 */
export const thisWeekTransactionsList: ListBuilderList = {
	id: 'default-transaction-this-week',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'This Week',
	type: 'default',
	active: true,
	sortOrder: 4,
	description: 'Transactions from the last 7 days',
	defaultSortId: 'column-transaction-dates-desc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		paymentDateRange: {
			defaultValue: [
				{
					id: 'this-week',
					label: 'This Week',
					data: {
						startDate: '{{DATE:-7d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
	},
};
